import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  plan: 'Sistema $100.000',
  quote: 'El planificador semanal me cambió la vida. Antes producía al azar. Ahora el lunes sé exactamente qué hacer y el viernes tengo los pedidos listos. Vendí 23 frasquitos en mi primer mes.'
}, {
  initials: 'PM',
  name: 'Patricia M.',
  location: 'Buenos Aires',
  plan: 'Megapack Completo',
  quote: 'El Tomo 6 sobre iglesias fue una revelación. Hablé con la líder de damas y me hicieron un pedido de 40 frasquitos para el retiro. ¡Llegué a mi meta volando!'
}, {
  initials: 'MG',
  name: 'Mariela G.',
  location: 'Córdoba',
  plan: 'Megapack Completo',
  quote: 'Armé mi primer catálogo en una tarde y esa misma semana vendí mis primeros 5 frasquitos. Nunca pensé que iba a ser tan fácil arrancar.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  plan: 'Sistema $100.000',
  quote: 'Los +500 mensajes del Tomo 2 son extraordinarios. Mis clientas me dicen que el rollito que sacaron ese día era exactamente lo que necesitaban escuchar.'
}, {
  initials: 'CS',
  name: 'Carmen S.',
  location: 'Buenos Aires',
  plan: 'Megapack Completo',
  quote: 'Con las respuestas listas para el cliente de WhatsApp cerré mi primer pedido en menos de 10 minutos.'
}];
export function Testimonials() {
  return <section className="py-16 sm:py-20 px-4 bg-[#F5EEFF] border-t border-white/5 relative pt-[6px] pb-[6px]" data-id="element-267">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-268">
        <div className="mb-10 sm:mb-14 flex flex-col items-center pt-[0px] pb-[0px]" data-id="element-269">
          <span className="text-3xl sm:text-4xl mb-3" aria-hidden data-id="element-270">
            ❤️
          </span>
          <h2 className="font-extrabold text-[#4A1B6D] text-[26px] sm:text-[40px] text-center mx-auto max-w-[18ch] sm:max-w-[22ch] uppercase tracking-tight" style={{
          lineHeight: 1.15,
          textShadow: '0 2px 6px rgba(74, 27, 109, 0.08)',
          fontWeight: 800
        }} data-id="element-271">
            Mujeres como vos que ya empezaron
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-272">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white p-6 rounded-3xl flex flex-col items-center h-full" style={{
          boxShadow: '0 10px 30px -10px rgba(74, 27, 109, 0.15), 0 4px 12px -4px rgba(74, 27, 109, 0.08)'
        }} data-id="element-273">
              <div className="flex gap-1 mb-4 text-[#C9A84C]" data-id="element-274">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" strokeWidth={0} data-id="element-275" />)}
              </div>

              <p className="text-gray-700 italic mb-6 text-[15px] leading-relaxed flex-grow" data-id="element-276">
                "{t.quote}"
              </p>

              <div className="flex flex-col items-center gap-3 pt-5 border-t border-gray-100 w-full mt-auto" data-id="element-277">
                <div className="w-14 h-14 rounded-full bg-[#4A1B6D] text-white flex items-center justify-center font-bold text-lg shadow-md" data-id="element-278">
                  {t.initials}
                </div>
                <div className="text-center" data-id="element-279">
                  <p className="font-bold text-gray-900 text-base" data-id="element-280">{t.name}</p>
                  <p className="text-sm text-gray-600 flex items-center gap-1.5 justify-center flex-wrap mt-1" data-id="element-281">
                    <span data-id="element-282">📍 {t.location}</span>
                    <span className="text-gray-300" data-id="element-283">|</span>
                    <span className="font-semibold text-[#4A1B6D]" data-id="element-284">
                      {t.plan}
                    </span>
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}